import { render, staticRenderFns } from "./BuildingsMap.vue?vue&type=template&id=cc88ca8a&"
import script from "./BuildingsMap.vue?vue&type=script&lang=ts&"
export * from "./BuildingsMap.vue?vue&type=script&lang=ts&"
import style0 from "./BuildingsMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc88ca8a')) {
      api.createRecord('cc88ca8a', component.options)
    } else {
      api.reload('cc88ca8a', component.options)
    }
    module.hot.accept("./BuildingsMap.vue?vue&type=template&id=cc88ca8a&", function () {
      api.rerender('cc88ca8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/BuildingsMap.vue"
export default component.exports